export { default } from './AuthenticatedLayout';
